import { Position } from '../../../shared/types/protocol.ts';
import { RecordPosition } from '../../types/sharedTypeImpl.ts';


export function getDeviation(recordPos: RecordPosition, position: Position): string {
    const value = recordPos.value as string | null;
    if (value == null || value === '') {
        return '';
    }

    const parsed = +value;
    if (isNaN(parsed)) {
        return '';
    }

    const middle = +position.nominal! + (+position.upperTolerance! + +position.lowerTolerance!) / 2;
    const deviation = parsed - middle;

    const numDecimals = value.split('.')[1]?.length || 0;
    return deviation.toFixed(numDecimals);
}
